import {
  Users,
  ShieldCheck,
  FolderOpen,
  FileImage,
  Wallet,
  Bell,
} from '../../shared/assets/AppIcons';
import { ROUTE_IDS, SHELL_IDS } from '@/app/router/route-constants';
import AdminTenantsPage from '@/modules/admin/pages/AdminTenantsPage';
import AdminCreateTenantPage from '@/modules/admin/pages/AdminCreateTenantPage';
import AdminControlPlaneClientsPage from '@/modules/admin/pages/AdminControlPlaneClientsPage';
import AdminControlPlaneClientDetailPage from '@/modules/admin/pages/AdminControlPlaneClientDetailPage';
import AdminRepositoryPage from '@/modules/admin/pages/AdminRepositoryPage';
import AdminAssetsPage from '@/modules/admin/pages/AdminAssetsPage';
import AdminBillingPage from '@/modules/admin/pages/AdminBillingPage';
import AdminNotificationsPage from '@/modules/admin/pages/AdminNotificationsPage';
import AdminTenantUsersPage from '@/modules/admin/pages/AdminTenantUsersPage';
import DashboardPage from '@/modules/dashboard/pages/DashboardPage';
import CalendarPage from '@/modules/calendar/pages/CalendarPage';
import DealsPage from '@/modules/deals/pages/DealsPage';
import DealProposalsPage from '@/modules/deals/pages/DealProposalsPage';
import DealsInProgressPage from '@/modules/deals/pages/DealsInProgressPage';
import CompletedDealsPage from '@/modules/deals/pages/CompletedDealsPage';
import ClientsPage from '@/modules/clients/pages/ClientsPage';
import { SupplierDetailPage, SuppliersPage } from '@/modules/suppliers';
import StaffPage from '@/modules/staff/pages/StaffPage';
import DocumentsPage from '@/modules/documents/pages/DocumentsPage';
import AccountingPage from '@/modules/accounting/pages/AccountingPage';
import ExpensesPage from '@/modules/accounting/pages/ExpensesPage';
import AutomationsPage from '@/modules/automations/pages/AutomationsPage';
import SettingsPage from '@/modules/settings/pages/SettingsPage';
import WorkspaceUsersPage from '@/modules/workspace-users/pages/WorkspaceUsersPage';
import { hasTenantRouteAccess } from './access-policy';
export { ROUTE_IDS, SHELL_IDS } from '@/app/router/route-constants';

export const DEFAULT_APP_ROUTE_ID = ROUTE_IDS.DASHBOARD;

export const adminRouteRegistry = [
  {
    id: ROUTE_IDS.ADMIN_TENANTS,
    path: '/admin/tenants',
    label: 'Tenant',
    icon: ShieldCheck,
    element: <AdminTenantsPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: true,
      section: 'platform',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_TENANTS_CREATE,
    path: '/admin/tenants/new',
    label: 'Crea tenant',
    icon: ShieldCheck,
    element: <AdminCreateTenantPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
      section: 'platform',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_TENANT_USERS,
    path: '/admin/tenants/:tenantId/users',
    label: 'Utenti tenant',
    element: <AdminTenantUsersPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_CONTROL_PLANE_CLIENTS,
    path: '/admin/clients',
    label: 'Clienti',
    icon: Users,
    element: <AdminControlPlaneClientsPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: true,
      section: 'platform',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_CONTROL_PLANE_CLIENT_DETAIL,
    path: '/admin/clients/:tenantId',
    label: 'Scheda cliente',
    icon: Users,
    element: <AdminControlPlaneClientDetailPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
      section: 'platform',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_REPOSITORY,
    path: '/admin/repository',
    label: 'Repository',
    icon: FolderOpen,
    element: <AdminRepositoryPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: true,
      section: 'product',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_ASSETS,
    path: '/admin/assets',
    label: 'Asset',
    icon: FileImage,
    element: <AdminAssetsPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: true,
      section: 'product',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_BILLING,
    path: '/admin/billing',
    label: 'Bilancio',
    icon: Wallet,
    element: <AdminBillingPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: true,
      section: 'company',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: ROUTE_IDS.ADMIN_NOTIFICATIONS,
    path: '/admin/notifications',
    label: 'Notifiche',
    icon: Bell,
    element: <AdminNotificationsPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: true,
      section: 'company',
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: 'admin-control-plane-clients-legacy',
    path: '/admin/clienti',
    label: 'Clienti legacy',
    element: <AdminControlPlaneClientsPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: 'admin-control-plane-client-detail-legacy',
    path: '/admin/clienti/:tenantId',
    label: 'Scheda cliente legacy',
    element: <AdminControlPlaneClientDetailPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: 'admin-billing-legacy',
    path: '/admin/bilancio',
    label: 'Bilancio legacy',
    element: <AdminBillingPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
  {
    id: 'admin-notifications-legacy',
    path: '/admin/notifiche',
    label: 'Notifiche legacy',
    element: <AdminNotificationsPage />,
    shell: SHELL_IDS.ADMIN,
    nav: {
      visible: false,
    },
    access: {
      requiredCapabilities: ['canAccessPlatformAdmin'],
    },
  },
];

export const appRouteRegistry = [
  {
    id: ROUTE_IDS.DASHBOARD,
    path: '/',
    label: 'Dashboard',
    header: { title: 'Dashboard', subtitle: 'Panoramica del workspace' },
    iconKey: 'nav.dashboard',
    element: <DashboardPage />,
    moduleKey: 'dashboard',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.ASSIGNMENTS,
    path: '/incarichi',
    label: 'Tasks',
    header: { title: 'Task', subtitle: 'Attività, richieste e scadenze' },
    iconKey: 'nav.tasks',
    element: <DealsPage />,
    moduleKey: 'deals',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.DEAL_PROPOSALS,
    path: '/proposte-affari',
    label: 'Proposte affari',
    header: { title: 'Proposte affari', subtitle: 'Opportunità da valutare e promuovere' },
    iconKey: 'nav.dealsProposals',
    element: <DealProposalsPage />,
    moduleKey: 'deals',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.DEALS_IN_PROGRESS,
    path: '/affari-in-corso',
    label: 'Affari in corso',
    header: { title: 'Affari in corso', subtitle: 'Lavorazioni attive e avanzamento' },
    iconKey: 'nav.dealsActive',
    element: <DealsInProgressPage />,
    moduleKey: 'deals',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.DEALS_COMPLETED,
    path: '/affari-completati',
    label: 'Affari completati',
    header: { title: 'Affari completati', subtitle: 'Storico delle lavorazioni concluse' },
    iconKey: 'nav.dealsCompleted',
    element: <CompletedDealsPage />,
    moduleKey: 'deals',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.CLIENTS,
    path: '/clienti',
    label: 'Clienti',
    header: { title: 'Clienti', subtitle: 'Anagrafiche e relazioni operative' },
    iconKey: 'nav.clients',
    element: <ClientsPage />,
    moduleKey: 'clients',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.SUPPLIERS,
    path: '/fornitori',
    label: 'Fornitori',
    header: { title: 'Fornitori', subtitle: 'Anagrafiche e collaborazioni' },
    iconKey: 'nav.suppliers',
    element: <SuppliersPage />,
    moduleKey: 'suppliers',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.SUPPLIER_DETAIL,
    path: '/fornitori/:supplierId',
    label: 'Dettaglio fornitore',
    header: { title: 'Fornitore', subtitle: 'Dettaglio anagrafico e operativo' },
    element: <SupplierDetailPage />,
    moduleKey: 'suppliers',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: false,
    },
  },
  {
    id: ROUTE_IDS.STAFF,
    path: '/personale',
    label: 'Personale',
    header: { title: 'Personale', subtitle: 'Team, ruoli e disponibilità' },
    iconKey: 'nav.team',
    element: <StaffPage />,
    moduleKey: 'staff',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.CALENDAR,
    path: '/calendario',
    label: 'Calendario',
    header: { title: 'Calendario', subtitle: 'Eventi, appuntamenti e scadenze' },
    iconKey: 'nav.calendar',
    element: <CalendarPage />,
    moduleKey: 'calendar',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.DOCUMENTS,
    path: '/documenti',
    label: 'Documenti',
    header: { title: 'Documenti', subtitle: 'Archivio e collegamenti documentali' },
    iconKey: 'nav.documents',
    element: <DocumentsPage />,
    moduleKey: 'documents',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.ACCOUNTING,
    path: '/contabilita-aziendale',
    label: 'Contabilità',
    header: { title: 'Contabilità', subtitle: 'Fatture, incassi e flussi economici' },
    iconKey: 'nav.accounting',
    element: <AccountingPage />,
    moduleKey: 'accounting',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.EXPENSES,
    path: '/uscite',
    label: 'Uscite',
    header: { title: 'Uscite', subtitle: 'Costi e pagamenti del workspace' },
    iconKey: 'nav.expenses',
    element: <ExpensesPage />,
    moduleKey: 'accounting',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.AUTOMATIONS,
    path: '/automazioni',
    label: 'Automazioni',
    header: { title: 'Automazioni', subtitle: 'Flussi e processi automatici' },
    iconKey: 'nav.settings',
    element: <AutomationsPage />,
    moduleKey: 'automations',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
  {
    id: ROUTE_IDS.WORKSPACE_USERS,
    path: '/utenti-workspace',
    label: 'Utenti',
    header: { title: 'Utenti', subtitle: 'Accessi e ruoli del workspace' },
    iconKey: 'nav.users',
    element: <WorkspaceUsersPage />,
    moduleKey: 'settings',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
    access: {
      requiredCapabilities: ['canManageWorkspaceUsers'],
    },
  },
  {
    id: ROUTE_IDS.SETTINGS,
    path: '/impostazioni',
    label: 'Impostazioni',
    header: { title: 'Impostazioni', subtitle: 'Configurazione del workspace' },
    iconKey: 'nav.settings',
    element: <SettingsPage />,
    moduleKey: 'settings',
    shell: SHELL_IDS.TENANT,
    nav: {
      visible: true,
    },
  },
];

export const auxiliaryRouteRegistry = [
  {
    id: ROUTE_IDS.CLIENTS_LEGACY_REDIRECT,
    path: '/clients',
    redirectTo: '/clienti',
    shell: SHELL_IDS.TENANT,
  },
  {
    id: ROUTE_IDS.SUPPLIERS_LEGACY_REDIRECT,
    path: '/suppliers',
    redirectTo: '/fornitori',
    shell: SHELL_IDS.TENANT,
  },
];

const appRoutesById = new Map(appRouteRegistry.map((route) => [route.id, route]));
const adminRoutesById = new Map(adminRouteRegistry.map((route) => [route.id, route]));

export function getAppRoutes() {
  return appRouteRegistry;
}

export function getAdminRoutes() {
  return adminRouteRegistry;
}

export function getAuxiliaryRoutes() {
  return auxiliaryRouteRegistry;
}

export function getRoutesByShell(routes = []) {
  return routes.reduce((groupedRoutes, route) => {
    const shellId = route.shell || SHELL_IDS.TENANT;

    if (!groupedRoutes[shellId]) {
      groupedRoutes[shellId] = [];
    }

    groupedRoutes[shellId].push(route);
    return groupedRoutes;
  }, {});
}

export function isRouteEnabledForTenant(route, access = {}) {
  return hasTenantRouteAccess(route, access);
}

export function resolveTenantRoutes(routes = [], access = {}) {
  return routes.filter((route) => isRouteEnabledForTenant(route, access));
}

export function getRouteById(routeId) {
  return appRoutesById.get(routeId) || adminRoutesById.get(routeId) || null;
}

export function getRoutePath(routeId) {
  return getRouteById(routeId)?.path || null;
}

export function buildRouteLocation(routeId, searchParams = {}) {
  const path = getRoutePath(routeId);

  if (!path) {
    return null;
  }

  const query = new URLSearchParams();

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    query.set(key, String(value));
  });

  const queryString = query.toString();

  return queryString ? `${path}?${queryString}` : path;
}

export function getDefaultAppRoutePath() {
  return getRoutePath(DEFAULT_APP_ROUTE_ID);
}

export function resolveTenantDefaultRoute(tenantConfig, availableRoutes = []) {
  const requestedDefaultRouteId = tenantConfig?.defaultRouteId;

  if (requestedDefaultRouteId) {
    const requestedRoute = availableRoutes.find((route) => route.id === requestedDefaultRouteId);

    if (requestedRoute) {
      return requestedRoute;
    }
  }

  const globalDefaultRoute = availableRoutes.find((route) => route.id === DEFAULT_APP_ROUTE_ID);

  if (globalDefaultRoute) {
    return globalDefaultRoute;
  }

  return availableRoutes[0] || null;
}

export function resolveTenantNavigationItems(items = [], access = {}) {
  return items
    .map((item) => {
      const route = getRouteById(item.routeId);

      if (
        !route ||
        route.nav?.visible === false ||
        !isRouteEnabledForTenant(route, access)
      ) {
        return null;
      }

      return {
        routeId: item.routeId,
        path: route.path,
        label: route.label,
        iconKey: route.iconKey,
        moduleKey: route.moduleKey,
      };
    })
    .filter(Boolean);
}
